import React from "react";
import { createPortal } from "react-dom";
import ConfirmModal from "../ConfirmModal";

const ConfirmModalTyped = ConfirmModal as unknown as React.ComponentType<{
  title?: string;
  content?: React.ReactNode;
  showCancel?: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
  modalWidth?: string | number;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler;
}>;

export interface DeleteCommentConfirmPortalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Overlay + ConfirmModal rendered in a portal (shared by FeedbackCard and UserCommentCard).
 */
export function DeleteCommentConfirmPortal({
  open,
  onConfirm,
  onCancel,
}: DeleteCommentConfirmPortalProps): React.ReactPortal | null {
  if (!open || typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.55)",
        zIndex: 30000,
      }}
      onClick={onCancel}
    >
      <ConfirmModalTyped
        title="Delete comment?"
        content="This comment will be deleted permanently."
        showCancel
        modalWidth="min(500px, calc(100vw - 32px))"
        onCancel={onCancel}
        onConfirm={onConfirm}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          zIndex: 30001,
        }}
        onClick={(event: React.MouseEvent) => event.stopPropagation()}
      />
    </div>,
    document.body,
  );
}
